import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function TransferStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M7.17867 9.58595C7.39228 9.36932 7.71553 9.30262 7.99703 9.41798C8.27857 9.53345 8.46285 9.80801 8.46285 10.1123V12.8984H12.7724C13.1864 12.8985 13.5221 13.2336 13.5224 13.6475L13.5234 17.5762C13.5235 17.7751 13.4442 17.9658 13.3037 18.1065C13.163 18.2472 12.9723 18.3262 12.7734 18.3262H8.46285V21.1123C8.46285 21.4166 8.27857 21.6912 7.99703 21.8067C7.71553 21.922 7.39228 21.8553 7.17867 21.6387L1.75484 16.1387C1.46714 15.8467 1.46714 15.3779 1.75484 15.0859L7.17867 9.58595ZM3.34175 15.6123L6.96285 19.2842V17.5762C6.96307 17.1622 7.29877 16.8262 7.71285 16.8262H12.0234L12.0224 14.3984H7.71285C7.51412 14.3984 7.32319 14.3191 7.18257 14.1787C7.04202 14.0382 6.96296 13.8472 6.96285 13.6484V11.9395L3.34175 15.6123ZM16.0029 2.19435C16.2844 2.07899 16.6076 2.14569 16.8212 2.36232L22.2451 7.86232C22.5328 8.15428 22.5328 8.62308 22.2451 8.91505L16.8212 14.415C16.6076 14.6317 16.2844 14.6984 16.0029 14.583C15.7213 14.4676 15.5371 14.193 15.5371 13.8887V11.1025H11.2275C10.8136 11.1025 10.4778 10.7674 10.4775 10.3535L10.4765 6.42482C10.4765 6.22593 10.5557 6.03523 10.6962 5.89454C10.8369 5.75384 11.0276 5.67482 11.2265 5.67482H15.5371V2.88868C15.5371 2.58438 15.7213 2.30981 16.0029 2.19435ZM17.0371 6.42482C17.0368 6.83884 16.7011 7.17482 16.2871 7.17482H11.9765L11.9775 9.60255H16.2871C16.7011 9.60255 17.0368 9.93853 17.0371 10.3525V12.0606L20.6572 8.38868L17.0371 4.71583V6.42482Z"
				fill="currentColor"
			/>
		</svg>
	);
}

TransferStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default TransferStrokeIcon;
